import { Box, Typography } from '@mui/material';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import { useAssetImageSrc } from '../utils/useAssetImageSrc';

interface Props {
  imageKey: string;
  assetUrl: string;
  alt?: string;
}

/** Full-size lightbox / modal image with CDN → API proxy fallback. */
const AssetLightBoxImage = ({
  imageKey,
  assetUrl,
  alt = 'Preview',
}: Props) => {
  const { src, failed, handleError } = useAssetImageSrc(imageKey, assetUrl);

  if (!imageKey || failed || !src) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          minHeight: 200,
        }}
      >
        <ImageOutlinedIcon sx={{ fontSize: 48, color: 'grey.500' }} />
        <Typography color='text.secondary'>Image unavailable</Typography>
      </Box>
    );
  }

  return (
    <Box
      component='img'
      src={src}
      alt={alt}
      onError={handleError}
      sx={{
        display: 'block',
        maxWidth: '90vw',
        maxHeight: '80vh',
        width: 'auto',
        height: 'auto',
        objectFit: 'contain',
        margin: 'auto',
      }}
    />
  );
};

export default AssetLightBoxImage;
